export const cadData = [
  { x: 0, y: 8441.73 },
  { x: 1, y: 7978.86 },
  { x: 2, y: 7553.17 },
  { x: 3, y: 8520.3 },
  { x: 4, y: 8226.23 },
  { x: 5, y: 8195.89 },
  { x: 6, y: 7855.19 },
  { x: 7, y: 7302.36 },
  { x: 8, y: 6956.13 },
  { x: 9, y: 6699.86 },
  { x: 10, y: 6175.51 },
  { x: 11, y: 5260.05 },
  { x: 12, y: 4811.2 },
  { x: 13, y: 4274.46 },
  { x: 14, y: 3880.35 },
  { x: 15, y: 3510.6 },
  { x: 16, y: 3267.37 },
  { x: 17, y: 2643.27 },
  { x: 18, y: 2636.7 },
  { x: 19, y: 2876.02 },
  { x: 20, y: 2845.71 },
  { x: 21, y: 3131.28 },
  { x: 22, y: 3281.9 },
  { x: 23, y: 3583.2 },
  { x: 24, y: 3759.53 },
  { x: 25, y: 3672.27 },
  { x: 26, y: 3681.8 },
  { x: 27, y: 4039.27 },
  { x: 28, y: 3858.78 },
  { x: 29, y: 3798.22 },
  { x: 30, y: 3795.36 },
  { x: 31, y: 3738.29 },
  { x: 32, y: 3717.65 },
  { x: 33, y: 3544.5 },
  { x: 34, y: 3517.96 },
  { x: 35, y: 3462.86 },
  { x: 36, y: 3430.35 },
  { x: 37, y: 3458.93 },
  { x: 38, y: 3384.85 },
  { x: 39, y: 3235.86 },
  { x: 40, y: 3187.22 },
  { x: 41, y: 3111.37 },
  { x: 42, y: 3174.02 },
  { x: 43, y: 3277.31 },
  { x: 44, y: 3536.38 },
  { x: 45, y: 3308.54 },
  { x: 46, y: 3269.14 },
  { x: 47, y: 3288.41 },
  { x: 48, y: 3242.21 },
  { x: 49, y: 3117.66 },
  { x: 50, y: 3030.9 },
  { x: 51, y: 2964.51 },
  { x: 52, y: 2992.49 },
  { x: 53, y: 2908.42 },
  { x: 54, y: 2991.93 },
  { x: 55, y: 2862.64 },
  { x: 56, y: 2929.32 },
  { x: 57, y: 2933.93 },
  { x: 58, y: 2782.01 },
  { x: 59, y: 3005.99 },
  { x: 60, y: 3283.66 },
  { x: 61, y: 3516.87 },
  { x: 62, y: 3773.96 },
  { x: 63, y: 4118.52 },
  { x: 64, y: 4259.57 },
  { x: 65, y: 4827.53 },
  { x: 66, y: 4978.26 },
  { x: 67, y: 5096.04 },
  { x: 68, y: 4870.53 },
  { x: 69, y: 4855.27 },
  { x: 70, y: 5029.23 },
  { x: 71, y: 5257.14 },
  { x: 72, y: 5139.73 },
  { x: 73, y: 5074.82 },
  { x: 74, y: 4877.16 },
  { x: 75, y: 4910.57 },
  { x: 76, y: 4539.71 },
  { x: 77, y: 4572.64 },
  { x: 78, y: 4474.78 },
  { x: 79, y: 4634.26 },
  { x: 80, y: 4399.1 },
  { x: 81, y: 4820.18 },
  { x: 82, y: 4768.4 },
  { x: 83, y: 4750.0 },
  { x: 84, y: 4490.8 },
  { x: 85, y: 4482.43 },
  { x: 86, y: 4324.32 },
  { x: 87, y: 4243.5 },
  { x: 88, y: 4051.94 },
  { x: 89, y: 6064.67 },
  { x: 90, y: 6001.99 },
  { x: 91, y: 6325.17 },
  { x: 92, y: 6173.44 },
  { x: 93, y: 9145.58 },
  { x: 94, y: 9026.02 },
];

export const ukData = [
  {
    y: 18067,
    x: 0,
  },
  {
    y: 17938,
    x: 1,
  },
  {
    y: 17677,
    x: 2,
  },
  {
    y: 17415,
    x: 3,
  },
  {
    y: 17181,
    x: 4,
  },
  {
    y: 16998,
    x: 5,
  },
  {
    y: 16885,
    x: 6,
  },
  {
    y: 16817,
    x: 7,
  },
  {
    y: 17255,
    x: 8,
  },
  {
    y: 17984,
    x: 9,
  },
  {
    y: 19763,
    x: 10,
  },
  {
    y: 21176,
    x: 11,
  },
  {
    y: 22674,
    x: 12,
  },
  {
    y: 23646,
    x: 13,
  },
  {
    y: 24775,
    x: 14,
  },
  {
    y: 24893,
    x: 15,
  },
  {
    y: 24844,
    x: 16,
  },
  {
    y: 24592,
    x: 17,
  },
  {
    y: 24096,
    x: 18,
  },
  {
    y: 23665,
    x: 19,
  },
  {
    y: 23134,
    x: 20,
  },
  {
    y: 23107,
    x: 21,
  },
  {
    y: 22987,
    x: 22,
  },
  {
    y: 22787,
    x: 23,
  },
  {
    y: 22617,
    x: 24,
  },
  {
    y: 22300,
    x: 25,
  },
  {
    y: 22384,
    x: 26,
  },
  {
    y: 22265,
    x: 27,
  },
  {
    y: 22296,
    x: 28,
  },
  {
    y: 22589,
    x: 29,
  },
  {
    y: 23226,
    x: 30,
  },
  {
    y: 24455,
    x: 31,
  },
  {
    y: 25618,
    x: 32,
  },
  {
    y: 26478,
    x: 33,
  },
  {
    y: 26909,
    x: 34,
  },
  {
    y: 27204,
    x: 35,
  },
  {
    y: 27253,
    x: 36,
  },
  {
    y: 27088,
    x: 37,
  },
  {
    y: 27009,
    x: 38,
  },
  {
    y: 26487,
    x: 39,
  },
  {
    y: 26059,
    x: 40,
  },
  {
    y: 25796,
    x: 41,
  },
  {
    y: 24715,
    x: 42,
  },
  {
    y: 23445,
    x: 43,
  },
  {
    y: 21745,
    x: 44,
  },
  {
    y: 20750,
    x: 45,
  },
  {
    y: 19827,
    x: 46,
  },
  {
    y: 19372,
    x: 47,
  },
];
